// extracted by css-extract-rspack-plugin
export default {"cls1":"FallbackBulkDownloadUpsellModalControl-cls1_Cd6","cls2":"FallbackBulkDownloadUpsellModalControl-cls2_gk5 FallbackBulkDownloadUpsellModalControl-cls1_Cd6"};